import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dependencies: {
		id: 'portfolio-3-portfolio.app-confluence-macro.main-new.common.header.dependencies',
		defaultMessage: 'Dependencies',
		description: 'Dependencies label for confluence macro title',
	},
});
